import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgBackToTop = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={22}
    height={22}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath="url(#a)" fill="#000">
      <path d="M17.686 14.857a.423.423 0 0 1-.134.308l-.67.67a.423.423 0 0 1-.615 0l-5.264-5.264-5.263 5.264a.423.423 0 0 1-.616 0l-.67-.67a.423.423 0 0 1 0-.616l6.241-6.241a.424.424 0 0 1 .616 0l6.241 6.241c.09.09.134.192.134.308Z" />
      <rect x={4} y={5} width={14} height={1.75} rx={0.5} />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h22v22H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgBackToTop;
